// @flow

import {makeStyles} from '@material-ui/core';
import React from 'react';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';

import funnelPreview from '../../../../../assets/img/chat/funnels-preview.png';
import CreateFunnelModal from '../Modals/CreateFunnelModal';
import {useToggle} from '../../../../../utils/react';

type Props = {};

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignItems: 'center',
  },
  funnelImg: {
    marginTop: 160,
    maxWidth: 300,
    '& img': {
      maxWidth: '100%',
    },
  },
}));
const FunnelInit = (props: Props) => {
  const classes = useStyles();

  const [modalOpen, toggleModalOpen] = useToggle(false);

  return (
    <div className={classes.root}>
      <div className={classes.funnelImg}>
        <img src={funnelPreview} alt="" />
      </div>
      <CustomButton variant="contained" onClick={toggleModalOpen}>
        Iniciar funnel
      </CustomButton>

      <CreateFunnelModal open={modalOpen} onClose={toggleModalOpen} />
    </div>
  );
};

export default FunnelInit;
